var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',[_c('app-navigation',{on:{"toggle-media":function($event){_vm.showMedia = !_vm.showMedia}}}),_vm._v(" "),_c('app-header'),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.showMedia)?_c('vue-medialibrary-manager',{on:{"close":function($event){_vm.showMedia = false}}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5022a46c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Default.vue
// module id = null
// module chunks = 